import CashierJackpotApi from './CashierJackpotApi'
export default CashierJackpotApi;
